import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { KineticLines } from "../components/Kinetic";
import { Seo } from "../components/Seo";
import { SUBURBS } from "../data/suburbs";

export default function Areas() {
    return (
        <main data-testid="areas-page" className="pt-16">
            <Seo title="Areas We Service — Adelaide's South | Lawn Busters"
                description="Lawn Busters services all Adelaide metro from our southern-suburbs base — Happy Valley, Flagstaff Hill, Woodcroft, Aberfoyle Park, Hallett Cove, Morphett Vale and more." />
            <section className="mx-auto max-w-6xl px-6 py-16 lg:py-24">
                <Reveal>
                    <p className="eyebrow text-forest-leaf">Areas we service</p>
                    <h1 className="mt-4 font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl">
                        <KineticLines lines={["Proudly Local", "To Adelaide"]} lineClassName="last:text-forest-leaf" />
                    </h1>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-moss">
                        We cover all of Adelaide metro, with the southern suburbs as our home base. Pick your
                        suburb to see what we do in your area — or just book straight in.
                    </p>
                </Reveal>
                <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {SUBURBS.map((s, i) => (
                        <Reveal key={s.slug} delay={i * 0.06}>
                            <Link to={`/areas/${s.slug}`} data-testid={`areas-card-${s.slug}`}
                                className="group flex h-full flex-col rounded-3xl border border-forest/10 bg-bone-card p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-ochre/50">
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-forest/10 text-forest transition-colors group-hover:bg-ochre group-hover:text-forest-night">
                                    <MapPin size={18} />
                                </span>
                                <h2 className="mt-5 font-display text-xl font-bold tracking-tight text-ink">{s.name}</h2>
                                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-ochre">{s.tag}</p>
                                <p className="mt-3 flex-1 text-sm leading-relaxed text-moss">{s.blurb}</p>
                                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-forest transition-colors group-hover:text-forest-leaf">
                                    Lawn care in {s.name} <ArrowRight size={14} />
                                </span>
                            </Link>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.1}>
                    <p className="mt-10 text-sm text-moss">
                        Somewhere else in Adelaide? We service all metro areas —{" "}
                        <Link to="/book-now?type=quote" data-testid="areas-quote-link" className="font-bold text-forest underline underline-offset-4 hover:text-forest-leaf">
                            get a free quote
                        </Link>{" "}
                        or call us to check your area.
                    </p>
                </Reveal>
            </section>
        </main>
    );
}
